import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTenant, getCSATenant, getCsaUserInfo,getCSATenant1 } from '../../actions/tenant';
import FullPageLoader from "../common/fullPageLoader";

export default function (ComposedComponent) {
  class Init extends React.Component {
    componentDidMount() {
      if (this.props.connection_id === null){
       
          const csaAuth = localStorage.getItem('csa_user_id');
          console.log(csaAuth)
          if(csaAuth !== null){
            const csaAuth = {
              "csa_user_id": localStorage.getItem('csa_user_id'),
              "csa_password": localStorage.getItem('csa_password')
            }
            this.props.getCSATenant1(csaAuth)
          }
          else{
            this.props.getCSATenant()
          }
          
        
      }
     // !!!this.props.connectionId && this.props.getTenant()
    }

    render() {
      const { loading, connection_id } = this.props;
      if (loading) {
        return <FullPageLoader />
      }
      if (connection_id === null) {
        return <FullPageLoader />
      }
      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    loading: state.tenant.loading,
    error: state.tenant.error,
    connection_id: state.tenant.connection_id,
    stylesheet_properties: state.tenant.stylesheet_properties,
    themeColor: state.landing.themeColor,
    presentURL: state.tenant.presentURL,
    isAuth: state.user.isAuth,
    login_image: state.tenant.login_image,
  });

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        getTenant, getCSATenant, getCsaUserInfo,getCSATenant1
      },
      dispatch
    );

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Init);
}